module.exports = __webpack_public_path__ + "c_static/img/进入我的购物车.3f0b163.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/进入我的购物车.png
// module id = df1S
// module chunks = 33